import ImageContentSection from "../../shared/ReusuableComponent/imagecontentsection/ImageContentSection";
import styles from "./WhoWeAre.module.css";
import Banner from "../../../src/img/staticimages/whoBanner.jpg";

const image1 =  "/staticimages/image1.svg";
const image2 =  "/staticimages/image2.svg";
const image3 =  "/staticimages/image3.svg";
const image4 =  "/staticimages/image4.svg";
const image5 =  "/staticimages/image5.svg";
const image6 =  "/staticimages/image6.svg";
const image7 =  "/staticimages/image7.svg";
const image8 =  "/staticimages/image8.svg";
const image9 =  "/staticimages/image9.svg";
const image10 =  "/staticimages/image10.svg";
const image11 =  "/staticimages/image11.svg";
const image12 =  "/staticimages/image12.svg";
const image13 =  "/staticimages/image13.svg";
const image14 =  "/staticimages/image14.svg";
const image15 =  "/staticimages/image15.svg";

const data = [
  {
    title: "15+ Years of Excellence",
    image: image1,
    description:
      "We are powered by 15+ years of dedicated experience since 2009.",
  },
  {
    title: "Expert Faculty Team",
    image: image2,
    description:
      "Our academy is led by highly experienced and qualified faculty members.",
  },
  {
    title: "Exam-Focused Study Materials",
    image: image3,
    description:
      "We provide well-structured, exam-oriented class materials for every subject.",
  },
  {
    title: "Continuous Student Support",
    image: image4,
    description:
      "Students receive continuous motivation and personal support throughout their journey.",
  },
  {
    title: "Affordable Fee Structure",
    image: image5,
    description:
      "We offer affordable course fees to make quality education accessible to all.",
  },
  {
    title: "Special Support for Village Students",
    image: image6,
    description:
      "Special guidance and support are provided for village-based students.",
  },
  {
    title: "Strong Learning Infrastructure",
    image: image7,
    description:
      "Our campus is equipped with strong infrastructure and a productive learning environment.",
  },
  {
    title: "Extensive Test Practice",
    image: image8,
    description:
      "We conduct a large number of topic-wise and full-length tests for better practice.",
  },
  //   {
  //     title: "Extensive Test Practice",
  //        image: image9,
  //     description:
  //       "We conduct a large number of topic-wise and full-length tests for better practice.",
  //   },
  {
    title: "Dedicated Mentorship",
    image: image9,
    description:
      "Students get regular mentorship and guidance from our teachers.",
  },

  {
    title: "Modern Teaching Methods",
    image: image10,
    description:
      "Students receive continuous motivation and personal support throughout their journey.",
  },
  {
    title: "Proven Results Every Year",
    image: image11,
    description:
      "Our consistent teaching approach has produced excellent results year after year.",
  },
  {
    title: "We Produced State Toppers",
    image: image12,
    description:
      "We are proud to have created several state toppers through our systematic training.",
  },
  {
    title: "Personalized Batch Attention",
    image: image13,
    description:
      "Each batch receives customized attention to ensure individual improvement.",
  },
  {
    title: "Smart Exam Strategies",
    image: image14,
    description:
      "Our learning strategies focus on both knowledge and smart exam techniques.",
  },
  {
    title: "Legacy of Trust & Success",
    image: image15,
    description:
      "With a legacy of trust and performance, ANNA IAS ACADEMY remains a top choice for competitive exam aspirants.",
  },
];

const WhyChooseUs = () => {
  return (
    <>
      <div>
        <img className={styles.imageSection} src={Banner} alt="images" />
      </div>
      <div className={styles.subwrapper}>
        <div className={styles.container}>
          <div className={styles.subheading}>Why Choose Anna IAS Academy</div>
        </div>
      </div>
      <ImageContentSection
        items={data}
        imageCol={2}
        contentCol={10}
        imageMaxWidth={210}
      />
    </>
  );
};

export default WhyChooseUs;
